import { PluginObject } from 'vue'

export const formatNumberPlugin: PluginObject<undefined> = {
  install: (Vue) => {
    Vue.prototype.$formatNumber = (number: number) => {
      return new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(number)
    }
  },
}
